import { Component } from "react";

export class BaseComponent extends Component {
  constructor(props) {
    super(props);

    this.eventMgr = window.eventEmitter;
  }
}



// WEBPACK FOOTER //
// ./src/base-component.js